module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/9-bdfaad1bf7ed36f1a192bdb2148d4f1b.svg";